import { HttpApiMiddleware, HttpApiSchema } from "@effect/platform";
import * as S from "effect/Schema";
/**
 * The discovery is switched off. Encoded exactly like a route the router does
 * not know (a 404 with no body), so a switched-off environment does not
 * advertise that the route exists.
 */
export const LoginMethodsUnavailable = S.Struct({
    _tag: S.Literal("LoginMethodsUnavailable"),
}).pipe(HttpApiSchema.asEmpty({
    status: 404,
    decode: () => ({ _tag: "LoginMethodsUnavailable" }),
}));
/** The caller's address has spent its discovery budget for the window. */
export const LoginMethodsRateLimited = S.Struct({
    _tag: S.Literal("LoginMethodsRateLimited"),
    retryAfterSeconds: S.Number,
}).annotations(HttpApiSchema.annotations({ status: 429 }));
/**
 * Admission to the public login-method discovery: the unified-access switch
 * and the anonymous rate limit. It is route middleware on the `auth` group, so
 * it runs on whatever request the router resolved to `POST /auth/methods`,
 * after the router's own path normalisation — an Express path match ahead of
 * the bridge cannot see spellings like `//auth/methods`, `/auth/%6Dethods` or
 * `/auth/methods;x`, which the router still resolves here. It runs before the
 * payload is decoded, so a switched-off route refuses even a malformed body
 * with the 404.
 *
 * apps/api provides it; it reads the caller's address from
 * {@link CLIENT_ADDRESS_HEADER}.
 */
export class LoginMethodsGate extends HttpApiMiddleware.Tag()("@pima/web-api/LoginMethodsGate", {
    failure: S.Union(LoginMethodsUnavailable, LoginMethodsRateLimited),
}) {
}
/**
 * Internal header the Express bridge uses to thread the caller's address into
 * the web handler for the discovery rate limit. Like the principal header, the
 * bridge builds the synthetic Request's headers from scratch and sets this one
 * from the resolved connection address, so an external caller cannot choose
 * the key it is limited under.
 */
export const CLIENT_ADDRESS_HEADER = "x-pima-web-client-address";
//# sourceMappingURL=login-methods-gate.js.map